document.addEventListener("DOMContentLoaded", function () {
  const descEl = document.querySelector(".top-description");
  const toggleBtn = document.querySelector(".toggle-description-btn");

  function updateDescriptionBehavior() {
    if (!descEl || !toggleBtn) return;

    const isMobile = window.innerWidth < 1024;

    if (isMobile) {
      toggleBtn.style.display = "inline-block";

      if (!toggleBtn.dataset.listenerAttached) {
        toggleBtn.addEventListener("click", function () {
          const expanded = descEl.classList.toggle("expanded");
          descEl.classList.toggle("collapsed", !expanded);
          toggleBtn.textContent = expanded ? "Read less" : "Read more";
        });
        toggleBtn.dataset.listenerAttached = "true";
      }

      if (
        !descEl.classList.contains("collapsed") &&
        !descEl.classList.contains("expanded")
      ) {
        descEl.classList.add("collapsed");
        toggleBtn.textContent = "Read more";
      }
    } else {
      descEl.classList.remove("collapsed", "expanded");
      toggleBtn.style.display = "none";
    }
  }

  function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  const debouncedResizeHandler = debounce(updateDescriptionBehavior, 300);

  updateDescriptionBehavior();

  window.addEventListener("resize", debouncedResizeHandler);
});
